import {Component, Inject, Injectable, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Estados } from 'app/shared/models/financas/documentos/estados';
import { EstadosMotivos } from 'app/shared/models/financas/documentos/estadosmotivos';
import { FinancasService } from 'app/shared/services/financas/financas.service';
import {Subscription} from 'rxjs';
import {LoginService} from '../../../../shared/services/aplicacao-service/login.service';
import {NotificacaoService} from '../../../../shared/services/notificacao/notificacao.service';
import {ModalAdicionarMotivoAnulacaoComponent} from '../modal-adicionar-motivo-anulacao/modal-adicionar-motivo-anulacao.component';
import {UtilizadorSessao} from '../../../../shared/models/aplicacao/utilizador-sessao';



@Component({
  selector: 'app-anular',
  templateUrl: './anular.component.html',
  styleUrls: ['./anular.component.scss'],
})
export class AnularComponent implements OnInit, OnDestroy {
  formAnularFact: FormGroup;
  estados: Estados[] = [];
  motivos: any[] = [];
  motivosTe: any;
  usaMotivos = true;
  codEstadoAnulado = 'A';
  subscricao: Subscription[] = [];
  modoAdicao: boolean;
  IdMotivoCtrl = new FormControl();
  CodEstadoCtrl = new FormControl();
  MotivoCtrl = new FormControl();
  motivoSeleccionado: any;
  opcoes: EstadosMotivos[] = [];
  idMotivo: number;
  msgErro: string;
  ctrlMotivoSelecionado = new FormControl();
  listaMotivosFiltro: EstadosMotivos[] = [];
  mostrarListaMotivos: boolean;
  utilizadorSessao: UtilizadorSessao;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private financasServices: FinancasService,
    private fb: FormBuilder,
    private alertService: NotificacaoService,
    private modalRef: MatDialogRef<AnularComponent>,
    private dialog: MatDialog,
    private loginService: LoginService,
  ) {
    this.getDadosSessaoUtilizador();
  }

  ngOnInit(): void {
    this.getMotivos(this.codEstadoAnulado);
    this.CodEstadoCtrl.setValue(this.codEstadoAnulado);
    if (this.data) { this.getEstados(this.data.tipo.id); }
  }

  getDadosSessaoUtilizador() {
    this.utilizadorSessao = this.loginService.getUtilizadorSessao();
  }
  filtrarAutocomplete(e: any) {
    const termo = e.target.value;
      if (termo) {
        this.opcoes = this.motivos.filter(
            x => x.motivoEstado && x.motivoEstado.toLowerCase().includes(termo.toLowerCase())
        );
      } else {
        this.opcoes = this.motivos;
      }
  }

  getEstados(idTipo: number) {
   this.subscricao.push(
       this.financasServices
       .getEstadosPeloTipoDocumento(idTipo)
       .subscribe((res) => {
         this.estados = res.filter((x) => x.codEstadoDocumento !== 'E');
         this.getMotivo(this.codEstadoAnulado);
       })
   );
  }

  getMotivos(codEstado) {
    this.subscricao.push(
        this.financasServices.getEstadosMotivos(codEstado).subscribe((res: any) => {
          if (res) { this.motivos = res.objecto;
             this.listaMotivosFiltro = res.objecto;  }
        })
    );
  }



  alterarEstadoDoc() {
    if(!this.motivoSeleccionado){
      this.alertService.notificar('Seleccione um motivo', false, 5000);
      return;
    }
    if (!this.CodEstadoCtrl.value) {
      this.CodEstadoCtrl.setValidators([Validators.required]);
      this.CodEstadoCtrl.updateValueAndValidity({onlySelf: true});
      this.CodEstadoCtrl.markAsTouched({onlySelf: true});
      return false;
    }
    if (!this.ctrlMotivoSelecionado.value) {
      this.ctrlMotivoSelecionado.setValidators([Validators.required]);
      this.ctrlMotivoSelecionado.updateValueAndValidity();
      this.ctrlMotivoSelecionado.markAsTouched({onlySelf: true});
      return false;
    }

    const doc = {
      idUtilizador: this.loginService.decodedToken?.nameid,
      idDocumento: this.data.idDocumento,
      idEstado: this.codEstadoAnulado,
      idMotivo: this.IdMotivoCtrl.value ? this.IdMotivoCtrl.value : null,

    };

    this.subscricao.push(
        this.financasServices.alterarEstadoDocumentoFA(doc)
            .subscribe(res => {
              this.modalRef.close({execucao: true, msg: res.mensagem});
            }, (error) => {
                this.alertService.notificar(error?.error?.mensagem ?? "Falha de conexão com a rede! Tente mais tarde.", false, 5000);
            })
    );
  }

  adicionarMotivo() {
    if (this.modoAdicao) {
      if (!this.MotivoCtrl.value) {
        this.MotivoCtrl.setValidators([Validators.required]);
        this.MotivoCtrl.markAsTouched({onlySelf: true});
        this.MotivoCtrl.updateValueAndValidity({onlySelf: true});
        return false;
      }
      const modelo  = {
        CodEstadoDocumento: this.codEstadoAnulado,
        MotivoEstado: this.MotivoCtrl.value
      };

      this.subscricao.push(
          this.financasServices.gravarMotivo(modelo).subscribe((res: any) => {
            // this.getMotivos(this.idEstadoAnulado); Para uso futuro
            this.motivos.push(res.objecto);
            if(!res.mensagem) {
              this.alertService.notificar('Motivo adicionado com sucesso!', true, 3000);
            } else {
              this.alertService.notificar(res.mensagem, true, 3000);
            }

            this.MotivoCtrl.reset();
            this.modoAdicao = false;
          }, error => {
            this.alertService.notificar(error.error, false, 3000);
          })
      );
    }
  }

  selecMotivo(motivo: EstadosMotivos) {
    this.IdMotivoCtrl.patchValue(motivo.idMotivoEstado);
    this.motivoSeleccionado = motivo;
    this.ctrlMotivoSelecionado.setValue(motivo.motivoEstado);
    this.mostrarListaMotivos = false;
  }

  getMotivo(codEstado: string) {
    this.IdMotivoCtrl.reset();
    this.MotivoCtrl.reset();
    const estado = this.estados.find((x) => x.codEstadoDocumento === codEstado);
    if (estado) {
      if (estado.usaMotivo) {
        this.CodEstadoCtrl.patchValue(estado.codEstadoDocumento);
        this.usaMotivos = estado.usaMotivo;
        this.subscricao.push(
            this.financasServices
                .getEstadosMotivos(estado.codEstadoDocumento).subscribe((res) => {
              this.motivos = res;
              this.opcoes = res;
            }));
      } else {
        this.CodEstadoCtrl.patchValue(estado.codEstadoDocumento);
        this.usaMotivos = false;
      }
    }
  }

  ngOnDestroy() {
    if (this.subscricao.length > 0) {
      this.subscricao.forEach(sub => {
        sub.unsubscribe();
      });
    }
  }

  adNovoMotivo() {
    const modalRef = this.dialog.open(ModalAdicionarMotivoAnulacaoComponent, {
      minWidth: '550px',
      minHeight: '240px',
    });

    modalRef.afterClosed().subscribe((res: any) => {
     this.getMotivos(this.codEstadoAnulado);
    });
  }
} // Fim da class componente //
